import { Divider, Stack } from '@mantine/core'
import { IFaqItem } from '@partment/types'
import { Card, Text } from '@repo/ui'
import { FC } from 'react'

interface IFAQProps {
  title: string
  FAQS: IFaqItem[]
}

export const FAQ: FC<IFAQProps> = ({ FAQS, title }) => {
  return (
    <Card shadow='sm' radius='xl' mt='lg' p='xl'>
      <Text
        mb='lg'
        c='var(--mantine-color-Neutral-8)'
        className='!font-semibold'
        fz='sm'
      >
        {title}
      </Text>

      {FAQS.map((faqItem, index) => (
        <Stack key={faqItem.question} py='xs'>
          <Text
            c='var(--mantine-color-Neutral-8)'
            className='!font-semibold'
            fz={13}
          >
            {faqItem.question}
          </Text>
          <Text
            fz={12}
            className='!text-[var(--mantine-color-Neutral-7)]'
            lh='160%'
          >
            {faqItem.answer}
          </Text>

          {index + 1 !== FAQS.length && <Divider />}
        </Stack>
      ))}
    </Card>
  )
}
